const baseURL = "/v1/Participante";

const service = {
  methods: {
    $buscarParticipante(cpf) {
      return this.$api().get(`${baseURL}/${cpf}` );
    },
    $cadastrarAtualizacaoCadastral(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarAtualizacaoCadastral(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $buscarDisciplina(params) {
      return this.$api().get(`${baseURL}/Disciplinas`, params);
    },
  },
};

export default service;